import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://c98dc79aef364a54b5588c01d4f50a13@o457526.ingest.sentry.io/5454207",
    integrations: [
      new VueIntegration({
        Vue,
      }),
    ],
  });
}

export default {
  init: async () => {},
};
